import { HttpHandler } from '../HttpHandler';
import { environment } from '../../enviroments';
import { ApiResponseType } from '../../shared/types/apiResponse.type';

export const checkIsEmailExist = async (email: string): Promise<ApiResponseType<boolean>> => {
  const { data } = await HttpHandler({
    method: 'GET',
    url: `${environment.AUTH_APP_URL}/auth/client/is-exists/by-email/?email=${email}`,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return data;
};

export const createCustomTokenForAnonymousUser = async (uid: string) => {
  if (!uid) {
    console.error('UID is not defined in createCustomTokenForAnonymousUser');
    return;
  }

  const { data } = await HttpHandler({
    method: 'POST',
    url: `${environment.AUTH_APP_URL}/auth/client/anonymous/create-custom-token`,
    data: {
      uid,
    },
  });

  return data;
};

export const mintCustomTokenForProviderOwnerEndpoint = async (providerId: string, providerToken: string) => {
  const { data } = await HttpHandler({
    method: 'POST',
    url: `${environment.AUTH_APP_URL}/auth/client/mint-custom-token/for-provider-owner`,
    data: {
      providerId,
      providerToken,
    },
  });

  return data;
};
